import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';

import wpcom, { APIError } from 'lib/wpcom-api';
import useOauth from 'data/oauth/use-oauth';
import { HostPartner } from './types';
import { TeamRole } from 'data/types';

export interface HostPartnerAPIResponse {
	show_all_sections: boolean;
	host_partner?: HostPartner;
	current_user_id?: number;
	current_user_role?: TeamRole;
	is_automattician: boolean;
	automattician_default_client: number | null;
}

const getHostPartner = ( token = '', atomicClientId?: string | null ) => {
	const path = atomicClientId
		? `/wpcom/v2/host-partners?atomic_client_id=${ atomicClientId }`
		: '/wpcom/v2/host-partners';
	return wpcom( token )
		.get<HostPartnerAPIResponse>( path )
		.then( response => response.data );
};

export default function useHostPartnerQuery() {
	const { oauth } = useOauth();
	const [ searchParams ] = useSearchParams();
	const atomicClientId = searchParams.get( 'atomic_client_id' );

	return useQuery<
		HostPartnerAPIResponse,
		APIError,
		HostPartnerAPIResponse
	>( {
		queryKey: [ 'host-partner', atomicClientId ],
		queryFn: () => getHostPartner( oauth.accessToken, atomicClientId ),
	} );
}
